import React, {useState} from "react"
import {Link} from "gatsby"
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from "reactstrap"
import "../styles/bootstrap.min.css"
import "../styles/main.css"
import "../styles/header.css"
import "../styles/element.css"
import "../styles/fontawesome.css"
import Contact from "../components/contact"


const Header = ({lang}) => { 
  const [isDropdown, setIsDropdown] = useState(false)
  const [isOpenContact, setOpenContact] = useState(false)

  return <>
     <div className="container desktop_res mt-2">
		<a className="navbar-brand logo_header" href="https://online.berjayasompo.com.my/">
			<img className="d-block w-100 img-fluid" src={"/homeNow/images/sompo_logo.svg"} alt="logo" />
      </a>
      <div className="prod-name_right mt-3">{lang.sompoHome}<span class="prod-name-italic">{lang.now}</span></div>
	</div>

	<nav className="navbar navbar-expand-lg mobile_res">
		<div className="container line-bottom online-menu_pad">
			<a className="navbar-brand logo_header" href="https://online.berjayasompo.com.my/">
				<img className="d-block w-100 img-fluid" src={"/homeNow/images/sompo_logo.svg"} alt="logo" />
			</a>
			<button className="navbar-toggler navbar-toggler-right mobile" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
				<span className="navbar-toggler-icon"></span>
			</button>
			<div className="collapse navbar-collapse" id="navbarResponsive">
				<ul className="navbar-nav ml-auto">
					<li className="nav-item mobile">
					</li>
					<li className="nav-item mobile">
						<Link className="nav-link" to={lang.homeLink}>{lang.home}</Link>
					</li>
					<li className="nav-item mobile">
            <a 
              className="nav-link"
              href="https://www.berjayasompo.com.my/claims"
              target="_blank"
              rel="noreferrer"
            >
              {lang.howToClaim}
            </a>
					</li>
				
				
            
					<li className="nav-item mobile">
						<a className="nav-link" href="#" onClick={() => setOpenContact(v => !v)}>
						{lang.contactUs}
            </a>
					</li>
					<li className="nav-item mobile">
						<a className="nav-link  no-line" href={lang.partnerWithUsLink}>{lang.partnerWithUs}</a>
					</li>
       
				</ul>
			</div>
      </div>
        <ul className="navbar-nav ml-auto">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle bold online-menu_pad2" href="#" id="navbarDropdownPortfolio" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			{lang.sompoHome}<span class="prod-name-italic">{lang.now}</span>
            </a>
						<div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownPortfolio">
							<a class="dropdown-item" href={lang.productLinks.motorNow}>SOMPO Motor</a>
							<a class="dropdown-item" href={lang.productLinks.motorSafe}>SOMPO MotorSafe</a>
  			  		<a class="dropdown-item" href={lang.productLinks.motorcycle}>SOMPO Motorcycle</a>
							{/* <a class="dropdown-item" href={lang.productLinks.medicNow}>SOMPO Medic<span class="prod-name-italic">Now</span></a> */}
							{/* <a class="dropdown-item" href={lang.productLinks.cashNow}>SOMPO Cash<span class="prod-name-italic">Now</span></a> */}
							<a class="dropdown-item hidden" href={lang.productLinks.homeNow}>SOMPO Home<span class="prod-name-italic">Now</span></a>
            	<a class="dropdown-item" href="https://online.berjayasompo.com.my/travel-insurance/">SOMPO TravelSafe+</a>
            </div>
          </li>
				</ul>
	</nav>

	<div className="text-right header_element"></div>
	
	<div className="bread_navi_bg desktop_res">
		<div className="container">
			<div className="row">
				<div className="col-xl-10 col-lg-9 col-md-8">
					<nav role="navigation" className="bread_navi">
						<ul>
							<li><Link to={lang.homeLink}>{lang.home}</Link></li>
							<li>
                <a 
                  href="https://www.berjayasompo.com.my/claims"
                  target="_blank"
                  rel="noreferrer"
                >
                  {lang.howToClaim}
                </a>
              </li>
				
							<li><a to="#" onClick={() => setOpenContact(v => !v)}>{lang.contactUs}</a></li>
							<li><Link to={lang.partnerWithUsLink}>{lang.partnerWithUs}</Link></li>
						</ul>
					</nav>
				</div>
				<div className="col-xl-2 col-lg-3 col-md-4">
					<nav className="navbar navbar-expand-lg">
						<div>
							<ul className="navbar-nav ml-auto">
                     <Dropdown nav={true} isOpen={isDropdown} toggle={() => setIsDropdown(prevState => !prevState)}>
                <DropdownToggle 
                  className="navbar-nav_desk"
                  caret 
                  tag="a" 
                  nav={true}
                  href="#"
                >
                  {lang.onlineProduct}
                </DropdownToggle>
								<DropdownMenu>
									<DropdownItem href={lang.productLinks.motorNow}>
										SOMPO Motor
									</DropdownItem>
									<DropdownItem className="hidden" href="https://customer.berjayasompo.com.my/directsales/policy?&_ga=2.254388168.1341727164.1598359407-2120574305.1595818765#/">
										SOMPO Motor
									</DropdownItem>
									<DropdownItem href={lang.productLinks.motorSafe}>
										SOMPO MotorSafe
									</DropdownItem>
									<DropdownItem href={lang.productLinks.motorcycle}>
										SOMPO Motorcycle
									</DropdownItem>
									{/* <DropdownItem href={lang.productLinks.medicNow}>
										SOMPO Medic<span className="prod-name-italic">Now</span>
									</DropdownItem> */}
									{/* <DropdownItem href={lang.productLinks.cashNow}>
										SOMPO Cash<span className="prod-name-italic">Now</span>
									</DropdownItem> */}
									<DropdownItem className="hidden" href={lang.productLinks.homeNow}>
										SOMPO Home<span className="prod-name-italic">Now</span>
									</DropdownItem>
									<DropdownItem href={lang.productLinks.travel}>
										SOMPO TravelSafe+
									</DropdownItem>
								</DropdownMenu>
							</Dropdown>
							</ul>
						</div>
					</nav>
				</div>
			</div>
		</div>
	</div>
  <Contact 
    isOpen={isOpenContact} 
    toggle={() => setOpenContact(v => !v)}
	lang={lang}
  />
  </>
}

export default Header